const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/posts/$draftId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/manage/posts/$draftId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Edit Post Draft",
      description: "Page title for CMS post draft edit page"
    })
  }
});